module.exports = __webpack_public_path__ + "static/gallery9-1d53bc9d64d312e6a7b81616e67ec0b9.jpg";